import { render, staticRenderFns } from "./PhysicianCheckinsItem.vue?vue&type=template&id=3390698e"
import script from "./PhysicianCheckinsItem.vue?vue&type=script&lang=js"
export * from "./PhysicianCheckinsItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports